<template>
  <div class="pt-3 dark:bg-gray-900 dark:text-gray-300">
    <div
      class="relative z-10 w-32 h-32 mx-auto overflow-hidden border-8 border-white rounded-xl"
    >
      <div class="flex items-center justify-center bg-gray-200 size-full">
        <img v-if="logo" :src="logo" :alt="name + 'Logo'" class="size-full" />
        <Icon v-else name="MdiImage" class="text-gray-300 size-8" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useBizStore } from "@/store/index.js";
export default {
  computed: {
    ...mapState(useBizStore, ["logo", "name"]),
  },
};
</script>
